import React from "react";
import { useTranslation } from "react-i18next";

import "./typing.css";
import globalData from "../../config/globaldata";
import { scrollToElement } from "../../config/globalfunction";

export default () => {
  const { t } = useTranslation();
  return (
    <div className="mainTypeBody">
      <div className="container">
        <div>
          <p className="typeHeading">{t("intro_slogan")}</p>
          <div className="typeHeadingBorder" />
        </div>
        <h1 className="brix_heading">
          <b>{globalData.name}</b>
          <br /> <span>We are</span>
          <br />
          <span
            className="txt-type"
            data-wait="2000"
            data-words='["Developers","Designers","Solution"]'
          ></span>
        </h1>
        <div className="topContactDiv">
          <span
            className="topContactText"
            onClick={() => scrollToElement("main8")}
          >
            {t("need_solution")}
          </span>
        </div>
      </div>
    </div>
  );
};

class TypeWriter {
  constructor(txtElement, words, wait = 3000) {
    this.txtElement = txtElement;
    this.words = words;
    this.txt = "";
    this.wordIndex = 0;
    this.wait = parseInt(wait, 10);
    this.type();
    this.isDeleting = false;
  }

  type() {
    // Current index of word
    const current = this.wordIndex % this.words.length;
    // Get full text of current word
    const fullTxt = this.words[current];

    // Check if deleting
    if (this.isDeleting) {
      // Remove char
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      // Add char
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    // Insert txt into element
    this.txtElement.innerHTML = `<span class="txt">${this.txt}</span>`;

    // Initial Type Speed
    let typeSpeed = 200;

    if (this.isDeleting) {
      typeSpeed /= 2;
    }

    // If word is complete
    if (!this.isDeleting && this.txt === fullTxt) {
      // Make pause at end
      typeSpeed = this.wait;
      // Set delete to true
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === "") {
      this.isDeleting = false;
      // Move to next word
      this.wordIndex++;
      // Pause before start typing
      typeSpeed = 500;
    }

    setTimeout(() => this.type(), typeSpeed);
  }
}

// Init On DOM Load
document.addEventListener("DOMContentLoaded", init);

// Init App
function init() {
  const txtElement = document.querySelector(".txt-type");
  const words = JSON.parse(txtElement.getAttribute("data-words"));
  const wait = txtElement.getAttribute("data-wait");
  // Init TypeWriter
  new TypeWriter(txtElement, words, wait);
}
